import AppStoreLogo from '../../../../assets/app-store-logo.jpg'
import GooglePlayLogo from '../../../../assets/google-play-logo.jpg'
import BesteHaendlerLogo from '../../../../assets/bestehaendler.jpg'
import TuevLogo from '../../../../assets/tuev-logo.jpg'
import BevhLogo from '../../../../assets/bevh-logo.jpg'
import KundenchampionsLogo from '../../../../assets/kundenchampions-logo.jpg'
import HvLogo from '../../../../assets/hv-logo.png'
import EmotaLogo from '../../../../assets/emota-logo.png'

import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

const certificates: TItem[] = [
  {
    image: TuevLogo,
    url: '/dpl/c/service/testurteile',
    label: 'TÜV Gütesiegel Sehr Gut',
    hideIn: [ELocale.DE_CH],
  },
  {
    image: BevhLogo,
    url: '/dpl/c/service/testurteile',
    label: 'bevh/EHI Geprüfter Online-Shop Gütesiegel',
    hideIn: [ELocale.DE_CH],
  },
  {
    image: KundenchampionsLogo,
    url: '/dpl/c/service/testurteile',
    label: 'Logo Deutschlands Kundenchampions 2020',
    hideIn: [ELocale.DE_AT, ELocale.DE_CH],
  },
  {
    image: HvLogo,
    url: '/dpl/c/service/testurteile',
    label: 'Logo Handelsverband Austria',
    hideIn: [ELocale.DE_DE, ELocale.DE_CH],
  },
  {
    image: EmotaLogo,
    url: '/dpl/c/service/testurteile',
    label: 'trust ECOMMERCE EUROPE Gütesiegel',
    hideIn: [ELocale.DE_CH],
  },
  {
    image: TuevLogo,
    url: '/dpl/c/service/testurteile',
    label: 'TÜV Gütesiegel Sehr Gut',
    hideIn: [ELocale.DE_DE, ELocale.DE_AT],
  },
  {
    image: BevhLogo,
    url: '/dpl/c/service/testurteile',
    label: 'bevh/EHI Geprüfter Online-Shop Gütesiegel',
    hideIn: [ELocale.DE_DE, ELocale.DE_AT],
  },
  {
    image: KundenchampionsLogo,
    url: '/dpl/c/service/testurteile',
    label: 'Logo Deutschlands Kundenchampions 2020',
    hideIn: [ELocale.DE_DE, ELocale.DE_AT],
  },
  {
    image: EmotaLogo,
    url: '/dpl/c/service/testurteile',
    label: 'Logo Handelsblatt Deutschlands beste Händler 1. Platz',
    hideIn: [ELocale.DE_DE, ELocale.DE_AT],
  },
  {
    image: BesteHaendlerLogo,
    url: '/dpl/c/service/testurteile',
    label: 'trust ECOMMERCE EUROPE Gütesiegel',
    hideIn: [ELocale.DE_CH, ELocale.DE_AT],
  },
]
const apps: TItem[] = [
  {
    image: AppStoreLogo,
    url:
      'https://itunes.apple.com/de/app/hse24/id1016812570?utm_source=webshop&utm_medium=footer&utm_campaign=AppStoreButton',
    label: 'Laden im Apple App Store',
    hideIn: [ELocale.DE_CH],
  },
  {
    image: GooglePlayLogo,
    url:
      'https://play.google.com/store/apps/details?id=de.hse24&utm_source=webshop&utm_medium=footer&utm_campaign=AppStoreButton',
    label: 'Jetzt bei Google Play',
    hideIn: [ELocale.DE_CH],
  },
]

export { certificates, apps }
